import ChannelManageHeader from '@/components/channels/verify/Header'
import VerifyChannelPostEmail from '@/components/channels/verify/PostEmail'
import VerifyEmailCode from '@/components/channels/verify/VerifyEmailCode'
import styled from '@emotion/styled'
import { Flex } from '@collable/ui'
import { useState } from 'react'

const EmailVerifyPage = () => {
  const [ownershipRequestId, setOwnershipRequestId] = useState<number | null>(null)
  return (
    <Container direction="column" gap={40} alignItems="center">
      <ChannelManageHeader />
      {ownershipRequestId ? (
        <VerifyEmailCode ownershipRequestId={ownershipRequestId} />
      ) : (
        <VerifyChannelPostEmail setOwnershipRequestId={setOwnershipRequestId} />
      )}
    </Container>
  )
}

export default EmailVerifyPage

const Container = styled(Flex)`
  min-width: 100vh;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.background.backgroundAlternative};
`
